export const CREATE_CSV_APPRAISERS = '@ds-resource/create-csv-appraisers'

export function createCsvAppraisers(data) {
  return {
    type: CREATE_CSV_APPRAISERS,
    data
  }
}
